var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "story-maker-highlight-menu" }, [
    _c("div", { staticClass: "btns-action" }, [
      _c("div", { staticClass: "btn cancel", on: { click: _vm.close } }, [
        _c("img", {
          attrs: {
            src: require("@/assets/img/instagram/instagram_x_outline_44.png"),
          },
        }),
      ]),
    ]),
    _c(
      "div",
      { staticClass: "bottom-sheet" },
      [
        _vm.highlights && Array.isArray(_vm.highlights)
          ? [
              (_vm.highlights.length == 0 && !_vm.highlightSelected) ||
              _vm.section == "newHighlight"
                ? [
                    _c("h4", [
                      _vm._v(
                        _vm._s(_vm.$t("dash.post-creator.story.highlight.new"))
                      ),
                    ]),
                    _c("div", { staticClass: "content-new-highlight" }, [
                      _c(
                        "div",
                        { staticClass: "container-highlight-picture" },
                        [
                          _c("div", { staticClass: "highlight-picture" }, [
                            _c(
                              "div",
                              {
                                staticClass: "container-img",
                                style: {
                                  backgroundColor:
                                    _vm.storySelected.background.color,
                                },
                              },
                              [
                                _vm.storySelected.background.file
                                  ? [
                                      _vm.storySelected.background.file.info
                                        .type2 == "image"
                                        ? _c("img", {
                                            attrs: {
                                              src: _vm.storySelected.background
                                                .file.url,
                                            },
                                          })
                                        : _vm.storySelected.background.file.info
                                            .type2 == "video"
                                        ? _c("video", {
                                            staticClass: "source",
                                            attrs: {
                                              src: _vm.storySelected.background
                                                .file.url,
                                              type: _vm.storySelected.background
                                                .file.info.type,
                                              preload: "metadata",
                                              onloadedmetadata: "true",
                                              muted: "",
                                              loop: "",
                                              playsinline: "",
                                            },
                                            domProps: { muted: true },
                                          })
                                        : _vm._e(),
                                    ]
                                  : _vm._e(),
                              ],
                              2
                            ),
                          ]),
                        ]
                      ),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.models.highlightName,
                            expression: "models.highlightName",
                          },
                        ],
                        attrs: {
                          placeholder: _vm.$t(
                            "dash.post-creator.story.highlight.name-placeholder"
                          ),
                        },
                        domProps: { value: _vm.models.highlightName },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.models,
                              "highlightName",
                              $event.target.value
                            )
                          },
                        },
                      }),
                      _vm.models.highlightName.length
                        ? _c(
                            "div",
                            {
                              staticClass: "button",
                              on: { click: _vm.addHighlight },
                            },
                            [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(
                                    _vm.$t(
                                      "dash.post-creator.story.highlight.add-button"
                                    )
                                  ) +
                                  "\n                    "
                              ),
                            ]
                          )
                        : _c(
                            "div",
                            {
                              staticClass: "button",
                              on: {
                                click: () => {
                                  if (!_vm.highlights.length) {
                                    _vm.close()
                                  } else {
                                    _vm.section = "home"
                                  }
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(_vm.$t("dash.button.go_back")) +
                                  "\n                    "
                              ),
                            ]
                          ),
                    ]),
                  ]
                : [
                    _c("h4", [
                      _vm._v(
                        _vm._s(
                          _vm.$t("dash.post-creator.story.highlight.add-to")
                        )
                      ),
                    ]),
                    _c("div", { staticClass: "content-pick-highlight" }, [
                      _c(
                        "div",
                        { staticClass: "list hide-scrollbar" },
                        [
                          [
                            _c(
                              "div",
                              {
                                staticClass: "container-highlight-new",
                                on: {
                                  click: function ($event) {
                                    _vm.section = "newHighlight"
                                  },
                                },
                              },
                              [
                                _c("div", { staticClass: "highlight-icon" }, [
                                  _c("img", {
                                    attrs: {
                                      src: require("@/assets/img/instagram/instagram_x_outline_44.png"),
                                    },
                                  }),
                                ]),
                                _c("p", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "dash.post-creator.story.highlight.new-label"
                                      )
                                    )
                                  ),
                                ]),
                              ]
                            ),
                            _vm.highlightSelected &&
                            !_vm.highlightSelected.id &&
                            _vm.highlightSelected.text
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "container-highlight-picture selected",
                                    on: { click: _vm.unSelectHighlight },
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "highlight-picture" },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "container-img",
                                            style: {
                                              backgroundColor:
                                                _vm.storySelected.background
                                                  .color,
                                            },
                                          },
                                          [
                                            _vm.storySelected.background.file
                                              ? [
                                                  _vm.storySelected.background
                                                    .file.info.type2 == "image"
                                                    ? _c("img", {
                                                        attrs: {
                                                          src: _vm.storySelected
                                                            .background.file
                                                            .url,
                                                        },
                                                      })
                                                    : _vm.storySelected
                                                        .background.file.info
                                                        .type2 == "video"
                                                    ? _c("video", {
                                                        staticClass: "source",
                                                        attrs: {
                                                          src: _vm.storySelected
                                                            .background.file
                                                            .url,
                                                          type: _vm
                                                            .storySelected
                                                            .background.file
                                                            .info.type,
                                                          preload: "metadata",
                                                          onloadedmetadata:
                                                            "true",
                                                          muted: "",
                                                          loop: "",
                                                          playsinline: "",
                                                        },
                                                        domProps: {
                                                          muted: true,
                                                        },
                                                      })
                                                    : _vm._e(),
                                                ]
                                              : _vm._e(),
                                          ],
                                          2
                                        ),
                                      ]
                                    ),
                                    _c("p", [
                                      _vm._v(
                                        _vm._s(_vm.highlightSelected.text)
                                      ),
                                    ]),
                                  ]
                                )
                              : _vm._e(),
                            _vm._l(_vm.highlights, function (highlight) {
                              return _c(
                                "div",
                                {
                                  class: [
                                    "container-highlight-picture",
                                    {
                                      selected:
                                        _vm.highlightSelected &&
                                        _vm.highlightSelected.id ==
                                          highlight.id,
                                    },
                                  ],
                                  on: {
                                    click: () => _vm.selectHighlight(highlight),
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "highlight-picture" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "container-img" },
                                        [
                                          _c("img", {
                                            attrs: { src: highlight.img },
                                          }),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _c("p", [_vm._v(_vm._s(highlight.title))]),
                                ]
                              )
                            }),
                          ],
                        ],
                        2
                      ),
                      _c(
                        "div",
                        { staticClass: "button", on: { click: _vm.close } },
                        [
                          _vm._v(
                            "\n                        " +
                              _vm._s(_vm.$t("dash.button.close")) +
                              "\n                    "
                          ),
                        ]
                      ),
                    ]),
                  ],
            ]
          : _c("span", { staticClass: "loader" }),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }